// @ts-nocheck

import betbuilderLogo from './BS_mymatch.png';
import combobooster from './combobooster.png';

export default {
  betbuilderLogo,
  combobooster,
};
